import { CategoryListOrderKey } from '../domain';
import { useListOrder } from '../../filter/hooks/useListOrder';

export const useCategoryListOrder = () => {
  return useListOrder(CategoryListOrderKey, 'categoryOrderBy');
};
